import * as C from './styles.js'
import { useNavigate } from 'react-router-dom';
import IconMemberPro from '../../../../components/images/member-pro.svg';
import { convertDate } from '../../../../components/convert-date/index.js';

export default function Signature({ user, account, signature }) {
    
    console.log(user)

    const navigate = useNavigate();

    function verifyStatusMember(dataTimestamp) {
        const dataAtual = Math.floor(Date.now() / 1000);
        return dataTimestamp > dataAtual;

    }

    return (
        <C.Container>

            <C.Header>
                <button onClick={()=>navigate('/configuracoes/principal/')}><i className='fas fa-chevron-left'></i></button>
                <h3>Assinatura</h3>
            </C.Header>

            <C.Main>
                <C.Section>
                    <h2>Assinante</h2>
                    <h4>{account?.account_name}</h4>
                    <p>{account?.account_email}</p>
                    <p>id da conta: {user?.uid}</p>
                </C.Section>
                <C.Section>
                    <h2>Assinatura</h2>
                    <h4>{signature?.account_type_name} <img src={IconMemberPro} alt="membro"/></h4>
                    <p>Você é um {signature?.account_description}</p>
                    <p>Status: {verifyStatusMember(signature?.account_member_until?.seconds) ? 'Ativo' : 'Expirado'}</p>
                    <div className='member-since-until'>
                        <p>Membro Desde: {convertDate(signature?.account_member_since?.seconds * 1000)}</p>
                        <p>Válido até: {convertDate(signature?.account_member_until?.seconds * 1000)}</p>
                    </div>
                </C.Section>
                <C.Section>
                    <p></p>
                </C.Section>
            </C.Main>
        </C.Container>
    )
}